import React, { useEffect, useState } from 'react'
import { Tracker } from '../../screens/tracker/Tracker'
import { Marketing } from '../../screens/marketing/Marketing'
import { Loading } from '../../screens/loading/Loading'
import { Error } from '../../screens/error/Error'
import { useLocation } from 'react-router'
import { getTracker } from '../../redux/modules/tracker/trackerAction'
import { useDispatch, useSelector } from 'react-redux'

export const TrackerRouter = () => {
	const { hash, search } = useLocation()
	const dispatch = useDispatch()
	const query = new URLSearchParams(search)
	const isDemo = query.get("demo") === "true"

	const {
		tracker: { loaded, error }, payment
	} = useSelector((state) => state.TrackerReducer)

	const user = useSelector((state) => state.UserReducer)

	const [headerAnimate, setHeaderAnimate] = useState(true)

	useEffect(() => {
		if (user.askInfos) {
			setHeaderAnimate(false)
		}
	}, [user.askInfos])

	useEffect(() => {
		if (!loaded) {
			setTimeout(() => {
				dispatch(getTracker(hash?.substr(1), isDemo))
			}, 1000)
		}
	}, [dispatch, hash, loaded, isDemo])

	useEffect(() => {
		if (payment) {
			window.posthog.capture('payment_tracker_view', {
				// eslint-disable-next-line camelcase
				payment_id: payment.id,
			})
		}
	}, [payment])

	if (error) {
		return <Error code={error?.response?.status} />
	}

	if (loaded) {
		if (user.askInfos) {
			return <Marketing />
		}

		return <Tracker headerAnimate={headerAnimate} isDemo={isDemo} />
	}

	return <Loading />
}
